import styled from "styled-components";

export const ProfileWrapper = styled.div`
  .content-head {
    background-color: var(--white);
    border-bottom: 1px solid var(--borderLight);
  }
  .logout-tab {
    svg [stroke] {
      stroke: var(--redColor);
    }
  }
  .profileContainer {
    display: flex;
    width: 100%;
    gap: 16px;
    @media (max-width: 767px) {
      flex-direction: column;
      gap: 10px;
      margin-top: 10px;
    }
  }
`;
export const ProfileBannerWrapper = styled.div`
  display: flex;
  width: 100%;
  background-color: var(--white);
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  overflow: hidden;
  flex-wrap: wrap;
  margin-bottom: 16px;
  .bannerImg {
    display: flex;
    width: 100%;
    position: relative;
    height: 263px;
    background-color: var(--border);
    & > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    
    .share-icon {
      position: absolute;
      right: 24px;
      bottom: 24px;
      z-index: 99;
      body.rtl & {
        right: unset;
        left: 24px;
      }
    }
    .icons-wrapper {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      right: 24px;
      bottom: 24px;
      z-index: 99;
      body.rtl & {
        right: unset;
        left: 24px;
      }
      @media (max-width: 991px) {
        display: none;
      }

      
    }
    .share-icon-my-profile {
      display: none;
      position: absolute;
      left: 24px;
      bottom: 24px;
      z-index: 99;
      @media (max-width: 991px) {
        display: block;
      }
      
    }
    .preview-icon {
      display: none;
      position: absolute;
      right: 24px;
      bottom: 24px;
      z-index: 99;
      @media (max-width: 991px) {
        display: block;
      }
    }
    .cover-save-btn {
      position: absolute;
      bottom: 20px;
      right: 15px;
      z-index: 999;
    }
    .editBanner {
      position: absolute;
      right: 24px;
      bottom: 24px;
      z-index: 99;
      body.rtl & {
          right: unset;
          left: 24px;
        }
    }
  }
  .profileContentWrapper {
    display: flex;
    width: 100%;
    min-height: 126px;
    .profileAvatarImgContainer {
      width: fit-content;
      height: fit-content;
      position: relative;
      margin-top: -30px;
      width: 132px;
      height: 132px;
      .profileAvatar {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 50%;
        border: 4px solid var(--white);
      }
      .profileCamera {
        position: absolute;
        background-color: var(--themeColorSecondary);
        border: 2px solid var(--white);
        border-radius: 50%;
        height: 44px;
        width: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        bottom: 4px;
        right: 0;
        svg {
          margin-top: -2px;
        }
        body.rtl & {
          right: unset;
          left: 0px;
        }
      }
    }
  }
  @media (max-width: 767px) {
    border-radius: 0px;
    box-shadow: none;
    margin-bottom: 0px;
    .bannerImg {
      height: 138px;
    }
    .editBanner {
      span {
        display: none;
      }
      /* bottom: auto !important;
			top: 1rem !important;
			right: 1rem !important; */
    }
  }
`;

export const DataContainer = styled.div`
  display: flex;
`;
export const NavSidebarWrapper = styled.div`
  max-width: 305px;
  min-width: 300px;
  height: 100%;
  position: relative;
  z-index: 190;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  background-color: var(--white);
  transition: 0.3s all;
  border-radius: 10px;
  padding: 16px;
  a {
    position: relative;
    padding: 12px 15px;
    transition: all ease-in-out 0.3s;
    font-size: 16px;
    color: var(--lightGrey);
    border-radius: 10px;
    gap: 15px;
    svg {
      width: 22px;
      height: 22px;
    }
    &:hover,
    &.active {
      background-color: var(--bg);

      &::before {
        opacity: 1;
      }
      svg {
        [stroke] {
          stroke: var(--themeColor);
        }
        [fill] {
          fill: var(--themeColor);
        }
      }
      span {
        color: var(--themeColor);
        font-family: var(--semiBold);
        body.rtl & {
          font-family: var(--arSemiBold);
        }
      }
    }
  }

  .sidebar-list {
    /* height: calc(100vh - 93px); */
    height: 100%;
    overflow-y: auto;
  }
  .close {
    width: 20px;
  }
  @media (max-width: 1199px) {
    max-width: 250px;
    min-width: 250px;
  }
  @media (max-width: 767px) {
    max-width: 100%;
    min-width: 100%;
    ul {
      display: flex;
      overflow-x: auto;
      a div {
        text-wrap: nowrap;
      }
    }
  }
`;
export const ProfileContent = styled.div`
  display: flex;
  width: 100%;
  background-color: var(--white);
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  flex-wrap: wrap;
`;
export const ProfileEditContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  flex-direction: column;
  .editProfileHeading {
    width: 100%;
    padding: 20px 24px 15px 24px;
    border-bottom: 1px solid var(--border);
  }
  .profileFormContainerInner {
    padding: 0px 24px 24px;
    .formBtns {
      display: flex;
      width: 100%;
      justify-content: flex-end;
      gap: 16px;
      padding-top: 16px;
    }
  }
`;

export const UserProfileContentWrapper = styled.div`
  display: block;
  width: 100%;
  justify-content: space-between;
  padding: 32px 24px;

  .userProfileDetailView {
    display: flex;
    /* width: fit-content; */
    align-items: flex-start;
    gap: 24px;
    .userProfileDetailAbout {
      padding-right: 70px;
      body.rtl & {
        padding-left: 70px;
      }
    }
    .userProfileAvatar {
      display: flex;
      min-width: 140px;
      max-width: 140px;
      height: 140px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .userProfileLogos {
      display: flex;
      gap: 24px;
      align-items: center;
    }
  }
  @media (max-width: 1199px) {
    .userProfileDetailView {
      .userProfileDetailAbout {
        padding-right: 10px;
        body.rtl & {
          padding-left: 10px;
        }
      }
    }
  }
  @media (max-width: 991px) {
    padding: 0 16px 32px 16px;
    margin-top: -70px;
    position: relative;
    z-index: 5;
    .userProfileDetailView {
      flex-wrap: wrap;
      justify-content: center;
      gap: 15px;
      .userProfileAvatar {
        border: 3px solid var(--white);
        border-radius: 50%;
      }
      .userProfileDetailAbout {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding-right: 0;
        & > div:first-child {
          width: 100%;
          text-align: center;
        }
        .peopleMainRoleWrapper {
          width: 100%;
          display: flex;
          justify-content: center;
          margin-bottom: 15px !important;
        }
        .userProfileAbout {
          order: 3;
          margin-top: 5px;
          text-align: center;
          > span {
            font-family: var(--semiBold);
            body.rtl & {
              font-family: var(--arSemiBold);
            }
          }
        }
      }
    }
    .socialPropStats {
      padding-top: 5px;
      & > div {
        justify-content: center;
      }
    }
  }
  @media (max-width: 499px) {
    padding: 0 16px 16px 16px;
  }
`;

export const SocialWrappper = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border-radius: 10px;
    border: 1px solid var(--border);
  }
  svg {
    width: 22px;
    height: auto;
    margin: 0 6px;
    [stroke] {
      stroke: ${({ iconColor }) =>
        iconColor ? iconColor : "var(--themeColorSecondary)"};
    }
    [fill] {
      fill: ${({ iconColor }) =>
        iconColor ? iconColor : "var(--themeColorSecondary)"};
    }
  }
  @media (max-width: 499px) {
    gap: 5px;
    a {
      width: 38px;
      height: 38px;
    }
  }
`;
export const PropertiesStatusWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
  margin-top: 30px;
  .propertiesStatusContainer {
    display: flex;
    padding: 19px 16px;
    border: 1px solid var(--border);
    border-radius: 10px;
    gap: 10px;
    width: 215px;
    .propertiesStatusBox {
      display: flex;
      min-width: 40px;
      max-width: 40px;
      height: 40px;
      background-color: #edf9fa;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-family: var(--bold);
      line-height: 1;
      color: var(--themeColorSecondary);
      border-radius: 6px;
      body.rtl & {
        font-family: var(--arBold);
      }
      .propertiesStatusExperience {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px solid var(--themeColorSecondary);
        width: 26px;
        height: 26px;
        border-radius: 50%;
        span {
          padding-top: 2px;
          line-height: 1;
        }
      }
    }
    .propertiesStatusTitleNum {
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      flex-direction: column;
      gap: 9px;
      p {
        width: fit-content;
      }
    }
  }
  @media (max-width: 991px) {
    margin-top: 15px;
  }
  @media (max-width: 499px) {
    /* flex-wrap: wrap; */
    gap: 8px;
    margin-top: 0x !important;
    .propertiesStatusContainer {
      font-size: 12px;
    }
  }
`;

export const ProfileContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
  margin-bottom: 16px;
  .profileContainerWrapper {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    max-width: 65%;
    gap: 16px;
  }
  @media (max-width: 991px) {
    flex-wrap: wrap;
    .profileContainerWrapper {
      max-width: 100%;
    }
    .lookingForContent {
      max-width: 100%;
    }
  }
  @media (max-width: 767px) {
    gap: 0;
    margin-bottom: 0;
    .profileContainerWrapper {
      gap: 0;
    }
  }
`;
